<!--
* @Name：议价审批阶梯价格
* @Author: 刘玉
* @Date: 2021-12-02 15:43:31
* @Last Modified by: 刘玉
* @Last Modified time: 2021-12-02 15:43:31
-->
<template>
  <div>
    <hi-card v-for="(item, index) in detailsList" :key="item.bargainItemId" :row-index="index + 1">
      <van-row>
        <span>物料编码：</span>
        <span>{{ item.matnr }}</span>
      </van-row>
      <van-row>
        <span>物料描述：</span>
        <span>{{ item.maktx }}</span>
      </van-row>
      <van-row>
        <span>供应商名称：</span>
        <span>{{ item.suppName }}</span>
      </van-row>
      <div v-if="item.bargainStepPriceDTOList">
        <van-row v-for="el in item.bargainStepPriceDTOList" :key="el.level">
          <span>{{ `${el.level}价格：` }}</span>
          <span>{{ el.price }}</span>
          &nbsp;
          <span>数量区间：</span>
          <span>{{ `${el.rangeStart ? el.rangeStart : ''}-${el.rangeEnd ? el.rangeEnd : ''}` }}</span>
        </van-row>
      </div>
    </hi-card>
  </div>
</template>

<script>
export default {
  name: 'TieredPricing',
  data() {
    return {
      detailsVisible: false
    }
  },
  props: {
    detailsList: {
      type: Array,
      default: () => []
    }
  }
}
</script>
